import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../../store';
import { ActionCreators } from '../../store/CulturesStore';

const useCultures = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(ActionCreators.GetCulturesIfNeeded());
	}, [dispatch, ActionCreators.GetCulturesIfNeeded]);

	return useSelector((state: IApplicationState) => state.cultures);
};

export default useCultures;
